// Page-level access rules for the Trust Center.
//   public  – anyone sees the page; requestable resources need an approved access request
//   gated   – visitor verifies an email whose domain is on the allowlist
//   private – only invited emails get in
// The API enforces these: it never sends gated / private content before the
// visitor is verified.

export const ACCESS_MODES = {
  public: {
    label: "Public",
    summary:
      "Anyone with the link can open the page. Requestable files still need your approval on Access requests.",
    visitorIntro: "",
  },
  gated: {
    label: "Allowed companies",
    summary:
      "Only listed company domains can open the page (after email verify). Not the same as Access requests for documents.",
    visitorIntro: "This page is shared with approved companies only.",
  },
  private: {
    label: "Invite only",
    summary: "Only people you invite by email can open the page.",
    visitorIntro: "This page is invite only.",
  },
};

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const DOMAIN_PATTERN = /^(?!-)[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}$/;

export const normalizeEmail = (email) =>
  String(email || "")
    .trim()
    .toLowerCase();
